import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';
import { CanceledError } from 'axios';

const getReviews = async (
  platform: string,
  company: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    if (platform === 'kununu') {
      const employee = await http.post(
        `/${platform}/reviews`,
        {
          company: company,
          kind: 'employee',
        },
        { signal }
      );
      const applicant = await http.post(
        `/${platform}/reviews`,
        {
          company: company,
          kind: 'applicant',
        },
        { signal }
      );
      loading(false);
      return [...employee.data, ...applicant.data];
    } else {
      const { data } = await http.post(
        `/${platform}/reviews`,
        {
          company: company,
        },
        { signal }
      );
      loading(false);
      return data;
    }
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const saveNote = async (id: string | number, note: string, type: string) => {
  try {
    await http.patch('/portal/editing/note', { reviewId: id, note: note, type: type });
  } catch (error) {
    console.error(error);
  }
};

const saveDeletion = async (id: string | number, deletion: boolean) => {
  try {
    await http.patch('/portal/editing/deletion', {
      reviewId: id,
      deletion: deletion,
    });
  } catch (error) {
    console.error(error);
  }
};

const saveStatus = async (id: string | number, status: string) => {
  try {
    await http.patch('/portal/editing/custom-status', {
      reviewId: id,
      status: status,
    });
  } catch (error) {
    console.error(error);
  }
};

const reviewHistory = async (
  company: string,
  platform: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.post(`/${platform}/reviews/history`, {
      company: company,
    });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const getReviewsByID = async (platform: string, id: string) => {
  try {
    const { data } = await http.get(`/${platform}/reviews/${id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const ReviewService = {
  getReviews,
  saveNote,
  saveDeletion,
  saveStatus,
  reviewHistory,
  getReviewsByID,
};

export default ReviewService;
